import { PlotFacingTypeEnum, PlotTypeEnum, PropertyAvailabilityStatusEnum } from 'pages/PropertyListing/types';
import { ListingStatusTypeEnum, PlotPaymentOptionEnum, PlotStatusFilterEnum, PlotToBuyState } from '.';
import { PlotSizeUnitTypeEnum } from 'pages/ServiceOrder/types';

export const initialState: PlotToBuyState = {
  List: [],
  loading: false,
  buttonLoading: false,
  search: '',
  pageNo: 1,
  pageSize: 10,
  totalRow: 0,
  orderBy: '',
  orderDir: '',
  status: PlotStatusFilterEnum.ALL,
  endDate: '',
  startDate: '',
  form: {
    _id: '',
    ticketId: '',
    address: '',
    name: '',
    location: {
      type: 'Point',
      coordinates: [0, 0]
    },
    plotSize: '',
    plotType: PlotTypeEnum.Null,
    minimumBudget: 0,
    maximumBudget: 0,
    approvals: [],
    availabilityStatus: PropertyAvailabilityStatusEnum.OPEN,
    plotFacing: PlotFacingTypeEnum.EAST,
    isActive: false,
    createdAt: '',
    updatedAt: '',
    plotSizeUnit: PlotSizeUnitTypeEnum.Null,
    paymentOption: PlotPaymentOptionEnum.NULL,
    status: ListingStatusTypeEnum.PENDING
  }
};
